import services from '@/config/services'

export default class LetturePdrService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getLetture(opts = {}){
    let items = []
    let totalItems = 0

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/pdrs/letture/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async updateMassivo(config){
    let item = {
      'letture': [],
      'success': false,
    }

    const url = `${this.baseUrl}/pdrs/letture/modifica`

    try {
      let res = await this.http.post(url, {
        data: config.data,
        filters: config.filters
      })

      res = res.data
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return item
    }
  }

}
